import Vue from 'vue'
import Router from 'vue-router'
import allFu from '../global/global'
import { getSearchString } from '../global/index'
Vue.use(Router)
// //解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   // console.log(location,'---location---',originalPush)
//   // if(location.path !== ('/' || '/login' )){
//   //   return originalPush.call(this, location).catch(err => err)
//   // }
//   return originalPush.call(this, location).catch(err => err)

// }

const vueRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/components/project-files/login'], resolve),
      beforeEnter: (to, from, next) => {
        let isMobile = true;
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
          /*window.location.href="你的手机版地址";*/
          isMobile = false;
        }
        else {
          /*window.location.href="你的电脑版地址";    */
          isMobile = true;
        }
        let pathName = "";
        let urlData = getSearchString();
        console.log(urlData, 'crm跳转过来的参数', localStorage.getItem('authorization'))
        const authorization = localStorage.getItem('authorization') ;
        if (authorization) {
          if (urlData && urlData.cookType) {
            pathName = isMobile ? '/login' : '/wxLogin';
          } else {
            pathName = isMobile ? '/hotelList' : '/hotelList';
          }

        } else {
          pathName = isMobile ? '/login' : '/wxLogin';
        }
        next(pathName);
      },
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/components/project-files/login'], resolve),
      beforeEnter: (to, from, next) => {
        const authorization = localStorage.getItem('authorization') ;
        let urlData = getSearchString();
        let isMobile = true;
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
          /*window.location.href="你的手机版地址";*/
          isMobile = false;
        }
        else {
          /*window.location.href="你的电脑版地址";    */
          isMobile = true;
        }
        console.log("触发")
        if (authorization) {
          // 清除从crm 跳转过来的
          if (urlData && urlData.cookType) {
            localStorage.removeItem('authorization');
            allFu.allFu.remove('authorization')
            if (!isMobile) {
              next('/wxLogin');
            } else {
              next()
            }
          } else {
            next('/hotelList');
          }
        } else {
          if (!isMobile) {
            next('/wxLogin');
          } else {
            next()
          }
        }
      }
    },
    {
      path: '/wxLogin',
      name: 'wxLogin',
      component: resolve => require(['@/components/project-files/mobile/wxLogin'], resolve),
      beforeEnter: (to, from, next) => {
        const authorization = localStorage.getItem('authorization');
        let isMobile = true;
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
          /*window.location.href="你的手机版地址";*/
          isMobile = false;
        }
        else {
          /*window.location.href="你的电脑版地址";    */
          isMobile = true;
        }
        if (authorization) {
          next('/hotelList');
        } else {
          if (isMobile) {
            next('/login');
          } else {
            next()
          }
        }
      }
    },
    {
      path: '/thirdLogin',
      name: 'thirdLogin',
      component: resolve => require(['@/components/project-files/thirdLogin'], resolve),
    },
    {
      path: '/wxRegister',
      name: 'wxRegister',
      component: resolve => require(['@/components/project-files/mobile/wxRegister'], resolve)
    },
    // {
    //   path: '/wxHotelList',
    //   name: 'wxHotelList',
    //   component: resolve => require(['@/components/project-files/mobile/wxHotelList'],resolve)
    // },
    {
      path: '/auth',
      name: 'auth',
      component: resolve => require(['@/components/project-files/hotel/auth'], resolve)
    },
    {
      path: '/agent',
      name: 'agent',
      component: resolve => require(['@/components/project-files/hotel/agent'], resolve)
    },

    {
      path: '/noFind',
      name: 'noFind',
      component: resolve => require(['@/components/project-files/noFind'], resolve)
    },
    {
      path: '/editPhone',
      name: 'editPhone',
      component: resolve => require(['@/components/project-files/fullScreen/editPhone'], resolve)
    },
    {
      path: '/editPassword',
      name: 'editPassword',
      component: resolve => require(['@/components/project-files/fullScreen/editPassword'], resolve)
    },
    {
      path: '/deterPassword',
      name: 'deterPassword',
      component: resolve => require(['@/components/project-files/fullScreen/deterPassword'], resolve)
    },
    {
      path: '/deterPhone',
      name: 'deterPhone',
      component: resolve => require(['@/components/project-files/fullScreen/deterPhone'], resolve)
    },
    {
      path: '/goRegister',
      name: 'goRegister',
      component: resolve => require(['@/components/project-files/goRegister'], resolve)
    },
    {
      path: '/helpPage',
      name: 'helpPage',
      component: resolve => require(['@/components/common/helpPage'], resolve)
    },
    {
      path: '/advertisement',
      name: 'advertisement',
      component: resolve => require(['@/components/project-files/fullScreen/advertisement'], resolve)
    },
    {
      path: '/hotelList',
      name: 'hotelList',
      component: resolve => require(['@/components/project-files/fullScreen/hotelList'], resolve)
    },
    {
      path: '/hotelListNew',
      name: 'hotelListNew',
      component: resolve => require(['@/components/project-files/fullScreen/hotelListNew'], resolve)
    },
    {
      path: '/accountManage',
      name: 'accountManage',
      component: resolve => require(['@/components/project-files/fullScreen/accountManage'], resolve)
    },
    {
      path: '/updateNotice',
      name: 'updateNotice',
      component: resolve => require(['@/components/project-files/fullScreen/updateNotice'], resolve),
    },
    {
      path: '/pay',
      name: 'pay',
      component: resolve => require(['@/components/project-files/fullScreen/pay'], resolve),
    },
    {
      path: '/videoPlay',
      name: 'videoPlay',
      component: resolve => require(['@/components/project-files/fullScreen/videoPlay'], resolve),
    },
    {
      path: '/common',
      component: resolve => require(['@/components/common/common'], resolve),
      children: [
        {
          path: '/myApp',
          name: 'myApp',
          component: resolve => require(['@/components/project-files/hotel/myApp'], resolve)
        },
        {
          path: '/myPicture',
          name: 'myPicture',
          component: resolve => require(['@/components/project-files/hotel/myPicture'], resolve)
        },
        {
          path: '/hotelInfo',
          name: 'hotelInfo',
          component: resolve => require(['@/components/project-files/fullScreen/hotelInfo'], resolve)
        },
        {
          path: '/themeStyle',
          name: 'themeStyle',
          component: resolve => require(['@/components/project-files/hotel/themeStyle'], resolve)
        },
        {
          path: '/information',
          name: 'information',
          component: resolve => require(['@/components/project-files/hotel/information'], resolve)
        },
        {
          path: '/language',
          name: 'language',
          component: resolve => require(['@/components/project-files/hotel/language'], resolve)
        },
        {
          path: '/deviceList',
          name: 'deviceList',
          component: resolve => require(['@/components/project-files/hotel/deviceList'], resolve)
        },
        {
          path: '/startUp',
          name: 'startUp',
          component: resolve => require(['@/components/project-files/hotel/startUp'], resolve)
        },
        {
          path: '/wifi',
          name: 'wifi',
          component: resolve => require(['@/components/project-files/hotel/wifi'], resolve)
        },
        {
          path: '/hotelSet',
          name: 'hotelSet',
          component: resolve => require(['@/components/project-files/hotel/hotelSet'], resolve)
        },
        {
          path: '/theme',
          name: 'theme',
          component: resolve => require(['@/components/project-files/hotel/theme'], resolve)
        },
        {
          path: '/welcome',
          name: 'welcome',
          component: resolve => require(['@/components/project-files/hotel/welcome'], resolve)
        },
        {
          path: '/contentPage',
          name: 'contentPage',
          component: resolve => require(['@/components/project-files/hotel/contentPage'], resolve)
        },
        {
          path: '/screenSaver',
          name: 'screenSaver',
          component: resolve => require(['@/components/project-files/hotel/screenSaver'], resolve)
        },
        {
          path: '/scrollNotice',
          name: 'scrollNotice',
          component: resolve => require(['@/components/project-files/hotel/scrollNotice'], resolve)
        },
        {
          path: '/imgNotice',
          name: 'imgNotice',
          component: resolve => require(['@/components/project-files/hotel/imgNotice'], resolve)
        },
        {
          path: '/videoNotice',
          name: 'videoNotice',
          component: resolve => require(['@/components/project-files/hotel/videoNotice'], resolve)
        },
        {
          path: '/urgentNotice',
          name: 'urgentNotice',
          component: resolve => require(['@/components/project-files/hotel/urgentNotice'], resolve)
        },
        {
          path: '/homeSet',
          name: 'homeSet',
          component: resolve => require(['@/components/project-files/hotel/homeSet'], resolve)
        },
        {
          path: '/upgrade',
          name: 'upgrade',
          component: resolve => require(['@/components/project-files/hotel/upgrade'], resolve),
        },
        {
          path: '/authorize',
          name: 'authorize',
          component: resolve => require(['@/components/project-files/hotel/authorize'], resolve),
        },
        {
          path: '/orderDevice',
          name: 'orderDevice',
          component: resolve => require(['@/components/project-files/hotel/orderDevice'], resolve)
        },
        {
          path: '/role',
          name: 'role',
          component: resolve => require(['@/components/project-files/hotel/role'], resolve),
        },
        {
          path: '/employ',
          name: 'employ',
          component: resolve => require(['@/components/project-files/hotel/employ'], resolve),
        },
        {
          path: '/foodRec',
          name: 'foodRec',
          component: resolve => require(['@/components/project-files/addService/foodRec'], resolve),
        },
        {
          path: '/attrNearby',
          name: 'attrNearby',
          component: resolve => require(['@/components/project-files/addService/attrNearby'], resolve),
        },
        {
          // 餐厅服务
          path: '/foodStore',
          name: 'foodStore',
          component: resolve => require(['@/components/project-files/addService/foodStore'], resolve),
        },
        {
          path: '/memory',
          name: 'memory',
          component: resolve => require(['@/components/project-files/hotel/memory'], resolve),
        },
        {// 在线统计
          path: '/onlineCouter',
          name: 'onlineCouter',
          component: resolve => require(['@/components/project-files/hotel/onlineCouter'], resolve),
        },
        {
          path: '/channel',
          name: 'channel',
          component: resolve => require(['@/components/project-files/hotel/channel'], resolve)
        },

        {

          path: '/broadcast',
          name: 'broadcast',
          component: resolve => require(['@/components/project-files/hotel/broadcast'], resolve)
        },
        {
          path: '/guide',
          name: 'guide',
          component: resolve => require(['@/components/project-files/hotel/guide'], resolve)
        }
      ]
    },
    {
      path: '*',
      name: 'notFound',
      component: resolve => require(['@/components/common/notFound'], resolve)
    },
  ]
})


export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js